import { render } from "./VdbVideoCard.vue?vue&type=template&id=6d656381&scoped=true"
import script from "./VdbVideoCard.vue?vue&type=script&lang=js"
export * from "./VdbVideoCard.vue?vue&type=script&lang=js"

import "./VdbVideoCard.vue?vue&type=style&index=0&id=6d656381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d656381"]])

export default __exports__